/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        layout: 'slider',
        swipe: true,
        media: 'adapt',
        onComplete: null
    };
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var shownSection = 0;
    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
            localStorage.setItem(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            if (Shopify.designMode && !cookieValue) {
                cookieValue = localStorage.getItem('shopify_recently_viewed');
            }
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function () {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            var position = jQuery.inArray(productHandle, recentlyViewed);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    // Purge legacy cache keys from previous versions
    (function purgeLegacyRvCache() {
        try {
            var keysToRemove = [];
            for (var i = 0; i < localStorage.length; i++) {
                var key = localStorage.key(i);
                if (key && key.indexOf('miki_rv_') === 0 && key.indexOf('miki_rv_v10_') !== 0) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach(function(k) { localStorage.removeItem(k); });
        } catch(e) {}
        try {
            var sKeysToRemove = [];
            for (var j = 0; j < sessionStorage.length; j++) {
                var skey = sessionStorage.key(j);
                if (skey && skey.indexOf('miki_rv_') === 0 && skey.indexOf('miki_rv_v10_') !== 0) {
                    sKeysToRemove.push(skey);
                }
            }
            sKeysToRemove.forEach(function(k) { sessionStorage.removeItem(k); });
        } catch(e) {}
    })();

    window.mikiRecentlyViewedCache = window.mikiRecentlyViewedCache || {};

    var fetchProductHtml = function (handle, viewParam) {
        var cacheKey = 'miki_rv_v10_' + handle + '_' + viewParam;
        if (window.mikiRecentlyViewedCache[cacheKey]) {
            return Promise.resolve({ handle: handle, html: window.mikiRecentlyViewedCache[cacheKey] });
        }
        try {
            var stored = localStorage.getItem(cacheKey) || sessionStorage.getItem(cacheKey);
            if (stored && stored.trim() !== '') {
                window.mikiRecentlyViewedCache[cacheKey] = stored;
                return Promise.resolve({ handle: handle, html: stored });
            }
        } catch (e) {}

        var url = (window.routes ? window.routes.root : '') + '/products/' + encodeURIComponent(handle) + '?view=' + viewParam;
        return fetch(url)
            .then(function (res) {
                if (!res.ok) throw new Error('Product not found');
                return res.text();
            })
            .then(function (html) {
                window.mikiRecentlyViewedCache[cacheKey] = html;
                try {
                    localStorage.setItem(cacheKey, html);
                    sessionStorage.setItem(cacheKey, html);
                } catch (e) {}
                return { handle: handle, html: html };
            })
            .catch(function () {
                cookie.remove(handle);
                return null;
            });
    };

    var finalize = function () {
        var items = wrapper.find('.item');
        if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

        wrapper.show();
        // If we have a callback.
        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    var moveAlong = function (wrapperP) {
        var handlesToLoad = productHandleQueue.slice(0, config.howManyToShow);
        if (!handlesToLoad.length) {
            finalize();
            return;
        }

        var fetchPromises = handlesToLoad.map(function (handle) {
            return fetchProductHtml(handle, 'ajax_recently_viewed');
        });

        Promise.all(fetchPromises).then(function (results) {
            var validResults = results.filter(function (r) { return r && r.html && r.html.trim() !== ''; });
            wrapperP.empty();
            validResults.forEach(function (item) {
                wrapperP.append(item.html);
            });
            finalize();
        });
    };

    var setupSliderAndCards = function(wrapperS, recentlyViewed, sectionId) {
        // Adjust form IDs for quick shop
        recentlyViewed.find('.card-product .variants-popup-content .selector-wrapper .swatch-element').each(function() {
            const $input = $(this).find('input');
            const $label = $(this).find('label');

            $input.attr({
                id: ($input.attr('id') || '') + sectionId,
                name: ($input.attr('name') || '') + sectionId
            });
            $label.attr('for', ($label.attr('for') || '') + sectionId);
        });

        recentlyViewed.find('.card-product').each(function() {
            const $qsForm = $(this).find('.variants-popup-content form');
            const $acForm = $(this).find('.card-action form');
            const $select = $(this).find('.variants-popup-content select');
            const $acButton = $(this).find('.card-action form button');
            const $qsButton = $(this).find('.variants-popup-content .product-card__button2 button');

            $qsForm.attr('id', ($qsForm.attr('id') || '') + sectionId);
            $acForm.attr('id', ($acForm.attr('id') || '') + sectionId);
            $select.attr('id', ($select.attr('id') || '') + sectionId);
            $acButton.attr('data-form-id', ($acButton.attr('data-form-id') || '') + sectionId);
            $qsButton.attr('data-form-id', ($qsButton.attr('data-form-id') || '') + sectionId);
        });

        if (config.layout == 'slider') {
            var productGrid = wrapperS,
                itemToShow = productGrid.data('item-to-show'),
                itemDots = productGrid.data('item-dots'),
                itemDotsMb = productGrid.data('item-dots-mb'),
                itemArrows = productGrid.data('item-arrows'),
                itemArrowsMb = productGrid.data('item-arrows-mb');

            if (productGrid.length > 0) {
                if (productGrid.not('.slick-initialized')) {
                    productGrid.slick({
                        mobileFirst: true,
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 1599,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    slidesToShow: itemToShow || 1,
                                    slidesToScroll: itemToShow || 1
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    slidesToShow: (itemToShow == 5 ? 4 : (itemToShow || 1)),
                                    slidesToScroll: (itemToShow == 5 ? 4 : (itemToShow || 1))
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 4,
                                    slidesToScroll: 4
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 3,
                                    slidesToScroll: 3
                                }
                            },
                            {
                                breakpoint: 320,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                }
                            }
                        ]
                    });
                }
            }

            if ($('body').hasClass('cursor-fixed__show')){
                window.sharedFunctionsAnimation?.onEnterButton();
                window.sharedFunctionsAnimation?.onLeaveButton();
            }

            if($('body').hasClass('product-card-layout-08')) {
                window.sharedFunctions?.productCountdownCard();
            }

            window.sharedFunctions?.swapHoverVideoProductCard();
            finalize();
        }
    };

    var formatMoneyCents = function(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.money_format) {
            return Shopify.formatMoney(cents, window.money_format);
        }
        var num = (cents / 100).toFixed(2);
        return 'Tk ' + num;
    };

    var buildCardHtmlFromObject = function(p, sectionId) {
        var discount = (p.compare_at_price && p.compare_at_price > p.price) ? Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price) : 0;
        var priceFormatted = formatMoneyCents(p.price);
        
        var minPrice = p.price_min || p.price;
        var maxPrice = p.price_max || p.price;
        var priceRangeHtml = '';
        if (p.price_varies && minPrice && maxPrice && minPrice !== maxPrice) {
            priceRangeHtml = '<div class="card-price-range">' + formatMoneyCents(minPrice) + ' - ' + formatMoneyCents(maxPrice) + '</div>';
        } else {
            priceRangeHtml = '<div class="card-price-range">' + priceFormatted + '</div>';
        }

        var imageSrc = p.featured_image || (p.images && p.images[0]) || '';
        if (typeof imageSrc === 'object' && imageSrc.src) imageSrc = imageSrc.src;
        if (imageSrc && !imageSrc.includes('width=')) {
            imageSrc = imageSrc.replace(/\.(jpg|jpeg|png|webp)/, '_300x.$1');
        }

        var badgeHtml = '';
        if (discount > 0) {
            badgeHtml += '<div class="ctp-badge ctp-sale-badge">Sale</div>';
        }
        if (!p.available) {
            badgeHtml += '<div class="ctp-badge ctp-sold-out-badge"' + (discount > 0 ? ' style="top: 36px;"' : '') + '>OUT OF STOCK</div>';
        }

        var buttonHtml = '';
        if (!p.available) {
            buttonHtml = '<button type="button" class="ctp-cart-btn button" disabled="disabled"><span>Sold Out</span></button>';
        } else {
            buttonHtml = '<button type="button" class="ctp-cart-btn button" data-open-product-options-popup data-product-handle="' + p.handle + '" data-product-id="' + p.id + '" aria-haspopup="dialog" aria-controls="halo-quick-view-popup" title="Add to Cart"><span>Add to Cart</span></button>';
        }

        return '<div class="product">' +
            '<div class="ctp-card">' +
                '<div class="ctp-image-wrap">' +
                    badgeHtml +
                    '<a href="' + p.url + '" tabindex="-1">' +
                        '<img src="' + imageSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="300" height="300" loading="eager">' +
                    '</a>' +
                    '<div class="miki-card-wishlist">' +
                        '<button type="button" title="Add to Wishlist" class="miki-card-wishlist-btn" data-wishlist data-wishlist-handle="' + p.handle + '" data-product-id="' + p.id + '" aria-label="Add to Wishlist">' +
                            '<svg class="icon-wishlist-empty" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#e53935" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
                            '<svg class="icon-wishlist-filled" viewBox="0 0 24 24" width="22" height="22" fill="#e53935" stroke="#e53935" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display: none;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
                        '</button>' +
                    '</div>' +
                '</div>' +
                '<div class="ctp-info">' +
                    '<a href="' + p.url + '" class="ctp-title">' + (p.title || '') + '</a>' +
                    '<div class="ctp-footer">' +
                        priceRangeHtml +
                        buttonHtml +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    };

    var doAlong = function (wrapperS) {
        const recentlyViewed = wrapperS.parents('.halo-recently-viewed-block');
        const sectionId = recentlyViewed.attr('sectionid') || '';
        const handlesToLoad = productHandleQueue.slice(0, config.howManyToShow);

        if (!handlesToLoad.length) {
            recentlyViewed.hide();
            return;
        }

        // FAST-PATH 1: Try stored JSON objects in localStorage (0ms synchronous render)
        try {
            var storedObjs = JSON.parse(localStorage.getItem('shopify_recently_viewed_objects') || '[]');
            if (storedObjs && storedObjs.length) {
                var objMap = {};
                storedObjs.forEach(function(o) { if (o && o.handle) objMap[o.handle] = o; });
                var objCards = [];
                var allObjsPresent = true;
                for (var j = 0; j < handlesToLoad.length; j++) {
                    if (objMap[handlesToLoad[j]]) {
                        objCards.push(buildCardHtmlFromObject(objMap[handlesToLoad[j]], sectionId));
                    } else {
                        allObjsPresent = false;
                        break;
                    }
                }
                if (allObjsPresent && objCards.length) {
                    wrapperS.empty();
                    objCards.forEach(function(c) { wrapperS.append(c); });
                    setupSliderAndCards(wrapperS, recentlyViewed, sectionId);
                    return;
                }
            }
        } catch(e) {}

        // FAST-PATH 2: Check if all items HTML are cached in localStorage
        var cachedItems = [];
        var allCached = true;
        for (var i = 0; i < handlesToLoad.length; i++) {
            var h = handlesToLoad[i];
            var key = 'miki_rv_v10_' + h + '_ajax_section_recently_viewed';
            var cached = (window.mikiRecentlyViewedCache && window.mikiRecentlyViewedCache[key]) || localStorage.getItem(key) || sessionStorage.getItem(key);
            if (cached && cached.trim() !== '') {
                cachedItems.push({ handle: h, html: cached });
            } else {
                allCached = false;
                break;
            }
        }

        if (allCached && cachedItems.length) {
            wrapperS.empty();
            cachedItems.forEach(function (item) {
                wrapperS.append(item.html);
            });
            setupSliderAndCards(wrapperS, recentlyViewed, sectionId);
            return;
        }

        const fetchPromises = handlesToLoad.map(function (handle) {
            return fetchProductHtml(handle, 'ajax_section_recently_viewed');
        });

        Promise.all(fetchPromises).then(function (results) {
            var validResults = results.filter(function (r) { return r && r.html && r.html.trim() !== ''; });

            if (!validResults.length) {
                recentlyViewed.hide();
                return;
            }

            wrapperS.empty();
            validResults.forEach(function (item) {
                wrapperS.append(item.html);
            });

            setupSliderAndCards(wrapperS, recentlyViewed, sectionId);
        });
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }

            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },

        showRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = config.templateId;
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && wrapper.length) {
                // Getting each product with an Ajax call and rendering it on the page.
                if (template == 'recently-viewed-product-popup') {
                    const wrapperP = wrapper;
                    moveAlong(wrapperP);
                } else {
                    const wrapperS = wrapper;
                    doAlong(wrapperS);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {
                // What is the product handle on this page.
                var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (splitted == null) {
                    var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                } else {
                    var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                }
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);

                // Pre-cache product card HTML in background for instant 0ms display on next page
                if (productHandle) {
                    var prefetchKey = 'miki_rv_' + productHandle + '_ajax_section_recently_viewed';
                    if (!localStorage.getItem(prefetchKey)) {
                        var prefetchUrl = (window.routes ? window.routes.root : '') + '/products/' + encodeURIComponent(productHandle) + '?view=ajax_section_recently_viewed';
                        fetch(prefetchUrl).then(function(r){ return r.text(); }).then(function(html){
                            if (html && html.trim() !== '') {
                                try {
                                    localStorage.setItem(prefetchKey, html);
                                    sessionStorage.setItem(prefetchKey, html);
                                } catch(e){}
                            }
                        }).catch(function(){});
                    }
                }
            }
        }
    };
})();
